import { parse } from '../../util/urlHelpers';
import reverse from 'lodash/reverse';
import sortBy from 'lodash/sortBy';
import axios from 'axios';
import { apiBaseUrl } from '../../util/api';
import { searchListings } from '../SearchPage/SearchPage.duck';
import { fetchCurrentUser, fetchCurrentWorkerUserExtraDetails } from '../../ducks/user.duck';
import { addMarketplaceEntities, getMarketplaceEntities } from '../../ducks/marketplaceData.duck';
import { TRANSITION_RESUME_JOB, TRANSITION_STARTING_JOB } from '../../util/transaction';
import moment from 'moment';
import { object } from 'prop-types';

const RESULT_PAGE_SIZE = 10;
const CONFIRM_ZERO_PAYMENT = 'transition/confirm-zero-payment';
const sortedTransactions = txs =>
  reverse(
    sortBy(txs, tx => {
      return tx.attributes ? tx.attributes.lastTransitionedAt : null;
    })
  );
// ================ Action types ================ //

export const FETCH_ALL_WORKERS_REQUEST = 'app/BusinessDashboard/FETCH_ALL_WORKERS_REQUEST';
export const FETCH_ALL_WORKERS_SUCCESS = 'app/BusinessDashboard/FETCH_ALL_WORKERS_SUCCESS';
export const FETCH_ALL_WORKERS_ERROR = 'app/BusinessDashboard/FETCH_ALL_WORKERS_ERROR';

export const FETCH_UNVERIFIED_WORKERS_REQUEST =
  'app/BusinessDashboard/FETCH_UNVERIFIED_WORKERS_REQUEST';
export const FETCH_UNVERIFIED_WORKERS_SUCCESS =
  'app/BusinessDashboard/FETCH_UNVERIFIED_WORKERS_SUCCESS';
export const FETCH_UNVERIFIED_WORKERS_ERROR =
  'app/BusinessDashboard/FETCH_UNVERIFIED_WORKERS_ERROR';

export const FETCH_LISTING_TRANSACTION_REQUEST =
  'app/BusinessDashboard/FETCH_LISTING_TRANSACTION_REQUEST';
export const FETCH_LISTING_TRANSACTION_SUCCESS =
  'app/BusinessDashboard/FETCH_LISTING_TRANSACTION_SUCCESS';
export const FETCH_LISTING_TRANSACTION_ERROR =
  'app/BusinessDashboard/FETCH_LISTING_TRANSACTION_ERROR';

export const FETCH_LISTING_AWAITING_ACCEPTANCE_REQUEST =
  'app/BusinessDashboard/FETCH_LISTING_AWAITING_ACCEPTANCE_REQUEST';
export const FETCH_LISTING_AWAITING_ACCEPTANCE_SUCCESS =
  'app/BusinessDashboard/FETCH_LISTING_AWAITING_ACCEPTANCE_SUCCESS';
export const FETCH_LISTING_AWAITING_ACCEPTANCE_ERROR =
  'app/BusinessDashboard/FETCH_LISTING_AWAITING_ACCEPTANCE_ERROR';

export const FETCH_APPLIED_LIST_REQUEST = 'app/BusinessDashboard/FETCH_APPLIED_LIST_REQUEST';
export const FETCH_APPLIED_LIST_SUCCESS = 'app/BusinessDashboard/FETCH_APPLIED_LIST_SUCCESS';
export const FETCH_APPLIED_LIST_ERROR = 'app/BusinessDashboard/FETCH_APPLIED_LIST_ERROR';

export const FETCH_WORKING_STAFF_REQUEST = 'app/BusinessDashboard/FETCH_WORKING_STAFF_REQUEST';
export const FETCH_WORKING_STAFF_SUCCESS = 'app/BusinessDashboard/FETCH_WORKING_STAFF_SUCCESS';
export const FETCH_WORKING_STAFF_ERROR = 'app/BusinessDashboard/FETCH_WORKING_STAFF_ERROR';

export const FETCH_ALL_BLOCKED_WORKERS_REQUEST =
  'app/BusinessDashboard/FETCH_ALL_BLOCKED_WORKERS_REQUEST';
export const FETCH_ALL_BLOCKED_WORKERS_SUCCESS =
  'app/BusinessDashboard/FETCH_ALL_BLOCKED_WORKERS_SUCCES';
export const FETCH_ALL_BLOCKED_WORKERS_ERROR =
  'app/BusinessDashboard/FETCH_ALL_BLOCKED_WORKERS_ERROR';

export const FETCH_FORMATTED_WORKING_STAFF_REQUEST =
  'app/BusinessDashboard/FETCH_FORMATTED_WORKING_STAFF_REQUEST';
export const FETCH_FORMATTED_WORKING_STAFF_SUCCESS =
  'app/BusinessDashboard/FETCH_FORMATTED_WORKING_STAFF_SUCCESS';
export const FETCH_FORMATTED_WORKING_STAFF_ERROR =
  'app/BusinessDashboard/FETCH_FORMATTED_WORKING_STAFF_ERROR';

// ================ Reducer ================ //

const initialState = {
  fetchInProgress: false,
  fetchAllWorkersError: null,
  pagination: null,
  currentPageWorkers: [],
  blockedWorkers: [],
  unverifiedWorkers: [],
  listingTransactions: {},
  fetchAppliedListInProgress: false,
  fetchAppliedlistSuccess: false,
  fetchAppliedlistError: null,
  workingStaffs: [],
  workingStaffsRequest: false,
  workingStaffsError: null,
  formattedWorkingStaffs: [],
};
const entityRefs = entities =>
  entities.map(entity => ({
    id: entity.id,
    type: entity.type,
  }));
export default function BusinessDashboardPageReducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case FETCH_ALL_WORKERS_REQUEST:
      return {
        ...state,
        fetchInProgress: true,
        fetchAllWorkersError: null,
        currentPageWorkers: [],
      };
    case FETCH_ALL_WORKERS_SUCCESS: {
      return {
        ...state,
        fetchInProgress: false,
        currentPageWorkers: payload.data.data.map(d => d.data.data),
        pagination: payload.data.meta,
      };
    }
    case FETCH_ALL_WORKERS_ERROR:
      console.error(payload); // eslint-disable-line
      return { ...state, fetchInProgress: false, fetchAllWorkersError: payload };
    case FETCH_ALL_BLOCKED_WORKERS_REQUEST:
      return {
        ...state,
        fetchInProgress: true,
        fetchAllWorkersError: null,
        currentPageWorkers: [],
        blockedWorkers: [],
      };
    case FETCH_ALL_BLOCKED_WORKERS_SUCCESS: {
      return {
        ...state,
        fetchInProgress: false,
        currentPageWorkers: [],
        blockedWorkers: [...payload],
      };
    }
    case FETCH_ALL_BLOCKED_WORKERS_ERROR:
      console.error(payload); // eslint-disable-line
      return { ...state, fetchInProgress: false, fetchAllWorkersError: payload };

    case FETCH_WORKING_STAFF_ERROR:
      console.error(payload); // eslint-disable-line
      return { ...state, workingStaffsRequest: false, fetchAllWorkersError: payload };

    case FETCH_WORKING_STAFF_REQUEST:
      return {
        ...state,
        workingStaffsRequest: true,
        fetchAllWorkersError: null,
        currentPageWorkers: [],
      };
    case FETCH_WORKING_STAFF_SUCCESS:
      const transactions = sortedTransactions(payload.data.data);
      return {
        ...state,
        workingStaffsRequest: false,
        currentPageWorkers: entityRefs(transactions),
        pagination: payload.data.meta,
      };

    case FETCH_UNVERIFIED_WORKERS_REQUEST:
      return {
        ...state,
        fetchInProgress: true,
        fetchUnverifiedWorkersError: null,
        currentPageWorkers: [],
      };
    case FETCH_UNVERIFIED_WORKERS_SUCCESS: {
      return {
        ...state,
        fetchInProgress: false,
        currentPageWorkers: payload.data.data,

        pagination: payload,
      };
    }
    case FETCH_UNVERIFIED_WORKERS_ERROR:
      console.error(payload); // eslint-disable-line
      return {
        ...state,
        fetchInProgress: false,
        fetchUnverifiedWorkersError: payload,
      };

    case FETCH_LISTING_TRANSACTION_REQUEST:
      return {
        ...state,
        fetchInProgress: true,
      };
    case FETCH_LISTING_TRANSACTION_SUCCESS: {
      return {
        ...state,
        fetchInProgress: false,
        listingTransactions: {
          ...state.listingTransactions,
          [payload.listingId]: payload.data,
        },
      };
    }
    case FETCH_LISTING_TRANSACTION_ERROR:
      console.error(payload); // eslint-disable-line
      return {
        ...state,
        fetchInProgress: false,
      };

    case FETCH_APPLIED_LIST_REQUEST:
      return {
        ...state,
        fetchInProgress: true,
        listingTransactions: {},
        fetchAppliedListInProgress: true,
      };
    case FETCH_APPLIED_LIST_SUCCESS: {
      return {
        ...state,
        fetchInProgress: false,
        fetchAppliedListInProgress: false,
        fetchAppliedlistSuccess: true,
      };
    }
    case FETCH_APPLIED_LIST_ERROR:
      console.error(payload); // eslint-disable-line
      return {
        ...state,
        fetchInProgress: false,
        fetchAppliedlistError: true,
      };
    case FETCH_LISTING_AWAITING_ACCEPTANCE_REQUEST:
      return {
        ...state,
        fetchInProgress: true,
        listingTransactions: {},
      };
    case FETCH_LISTING_AWAITING_ACCEPTANCE_SUCCESS: {
      return {
        ...state,
        fetchInProgress: false,
        currentPageWorkers: payload.data,
        pagination: payload.meta,
      };
    }
    case FETCH_LISTING_AWAITING_ACCEPTANCE_ERROR:
      console.error(payload); // eslint-disable-line
      return {
        ...state,
        fetchInProgress: false,
      };
    case FETCH_FORMATTED_WORKING_STAFF_ERROR:
      console.error(payload); // eslint-disable-line
      return { ...state, workingStaffsRequest: false, fetchAllWorkersError: payload };

    case FETCH_FORMATTED_WORKING_STAFF_REQUEST:
      return {
        ...state,
        workingStaffsRequest: true,
        fetchAllWorkersError: null,
        currentPageWorkers: [],
      };
    case FETCH_FORMATTED_WORKING_STAFF_SUCCESS:
      return {
        ...state,
        workingStaffsRequest: false,
        currentPageWorkers: payload,
      };
    default:
      return state;
  }
}
// ================ Action creators ================ //

const fetchAllWorkersRequest = () => ({ type: FETCH_ALL_WORKERS_REQUEST });
const fetchAllWorkersSuccess = response => ({
  type: FETCH_ALL_WORKERS_SUCCESS,
  payload: response,
});
const fetchAllWorkersError = e => ({
  type: FETCH_ALL_WORKERS_ERROR,
  error: true,
  payload: e,
});
const fetchAllBlockedWorkersRequest = () => ({ type: FETCH_ALL_BLOCKED_WORKERS_REQUEST });
const fetchAllBlockedWorkersSuccess = response => ({
  type: FETCH_ALL_BLOCKED_WORKERS_SUCCESS,
  payload: response,
});
const fetchAllBlockedWorkersError = e => ({
  type: FETCH_ALL_BLOCKED_WORKERS_ERROR,
  error: true,
  payload: e,
});
const fetchWorkingStaffRequest = () => ({ type: FETCH_WORKING_STAFF_REQUEST });
const fetchWorkingStaffSuccess = response => {
  return {
    type: FETCH_WORKING_STAFF_SUCCESS,
    payload: response,
  };
};
const fetchWorkingStaffError = e => ({
  type: FETCH_WORKING_STAFF_ERROR,
  error: true,
  payload: e,
});
const fetchFormattedWorkingStaffRequest = () => ({ type: FETCH_FORMATTED_WORKING_STAFF_REQUEST });
const fetchFormattedWorkingStaffSuccess = response => {

  return {
    type: FETCH_FORMATTED_WORKING_STAFF_SUCCESS,
    payload: response,
  };
};
const fetchFormattedWorkingStaffError = e => ({
  type: FETCH_FORMATTED_WORKING_STAFF_ERROR,
  error: true,
  payload: e,
});
const fetchAllUnverifiedWorkersRequest = () => ({ type: FETCH_UNVERIFIED_WORKERS_REQUEST });
const fetchAllUnverifiedWorkersSuccess = response => ({
  type: FETCH_UNVERIFIED_WORKERS_SUCCESS,
  payload: response,
});
const fetchAllUnverifiedWorkersError = e => ({
  type: FETCH_UNVERIFIED_WORKERS_ERROR,
  error: true,
  payload: e,
});

const fetchAppliedListRequest = () => ({ type: FETCH_APPLIED_LIST_REQUEST });
const fetchAppliedListSuccess = response => ({
  type: FETCH_APPLIED_LIST_SUCCESS,
});
const fetchAppliedListError = e => ({
  type: FETCH_APPLIED_LIST_ERROR,
  error: true,
  payload: e,
});

const fetchListingAwaitingAcceptanceRequest = () => ({
  type: FETCH_LISTING_AWAITING_ACCEPTANCE_REQUEST,
});
const fetchListingAwaitingAcceptanceSuccess = response => ({
  type: FETCH_LISTING_AWAITING_ACCEPTANCE_SUCCESS,
  payload: response,
});
const fetchListingAwaitingAcceptanceError = e => ({
  type: FETCH_LISTING_AWAITING_ACCEPTANCE_ERROR,
  error: true,
  payload: e,
});

const fetchListingTransactionsRequest = () => ({ type: FETCH_LISTING_TRANSACTION_REQUEST });
const fetchListingTransactionsSuccess = response => ({
  type: FETCH_LISTING_TRANSACTION_SUCCESS,
  payload: response,
});
const fetchListingTransactionsError = e => ({
  type: FETCH_LISTING_TRANSACTION_ERROR,
  error: true,
  payload: e,
});
// ================ Thunks ================ //

export const fetchAllWorkers = param => (dispatch, getState, sdk) => {
  const { page = 1 } = param;
  dispatch(fetchAllWorkersRequest());

  return axios
    .get(`${apiBaseUrl()}/api/user/business/allworkers?page=${page}`, {
      withCredentials: true,
    })
    .then(response => {
      dispatch(fetchAllWorkersSuccess(response));
    })
    .catch(error => {
      dispatch(fetchAllWorkersError(error));
    });
};
export const fetchWorkingStaff = param => async (dispatch, getState, sdk) => {
  const { page = 1 } = param;
  dispatch(fetchFormattedWorkingStaffRequest());
  await dispatch(fetchCurrentUser());
  const currentUser = getState().user.currentUser;
  const currentUserId = currentUser?.id?.uuid;

  axios
    .post(
      `${apiBaseUrl()}/api/timeStatement/fetchWorkingStaff`,
      { currentUserId },
      { withCredentials: true }
    )
    .then(res => {
      const workerIdArray = res?.data?.map(m => m.workerSharetribeId);
      return Promise.allSettled(
        workerIdArray.map(m =>
          sdk.users.show(
            {
              id: m,
              include: ['profileImage', 'profile.publicData'],
              'fields.image': [
                'variants.default',
                'variants.square-small',
                'variants.square-small2x',
              ],
            },
            { expand: true }
          )
        )
      );
    })

    .then(res => {
      const successfulResults = res
        .filter(result => result.status === 'fulfilled')
        .map(result => result.value);
      const result = successfulResults.map(m => {
        dispatch(fetchCurrentWorkerUserExtraDetails(m.data.data.id.uuid)).then(res => {
          Object.assign(m?.data?.data?.attributes?.profile?.publicData, res);
        });
        dispatch(addMarketplaceEntities(m));
        return m.data;
      });
      const ids = result.map(m => m?.data?.id?.uuid);
      axios
        .post(`${apiBaseUrl()}/api/user/isBlockedForWorking`, {
          providerID: currentUser?.id?.uuid,
          ids,
        })
        .then(res => {
          const blockedIds = res.data.map(m => m.blockedWorkerId);
          const filteredData = result.filter(f => !blockedIds.includes(f?.data?.id?.uuid));
          return dispatch(fetchFormattedWorkingStaffSuccess(filteredData));
        });
    })

    .catch(e => {
      console.log(e);
      fetchFormattedWorkingStaffError(e);
    });
};

export const fetchFavourites = param => async (dispatch, getState, sdk) => {
  const { page = 1 } = param;
  dispatch(fetchAllWorkersRequest());

  await dispatch(fetchCurrentUser());
  const fetchedcurrentUser = getState().user.currentUser;

  const id = fetchedcurrentUser?.attributes?.profile?.protectedData?.favourites || [];
  return axios
    .post(
      `${apiBaseUrl()}/api/user/admin/fetchFavourites?page=${page}`,
      {
        id,
      },
      { withCredentials: true }
    )
    .then(response => {
      response.data.map(m => {
        dispatch(fetchCurrentWorkerUserExtraDetails(m?.data?.data?.id?.uuid)).then(res => {
          Object.assign(m?.data?.data?.attributes?.profile?.publicData, res);
        });
        dispatch(addMarketplaceEntities(m));
      });
      const sp = { data: { data: response.data, included: {}, meta: {} } };
      dispatch(fetchAllWorkersSuccess(sp));
    })
    .catch(error => {
      dispatch(fetchAllWorkersError(error));
    });
};
export const fetchBlockedUser = param => async (dispatch, getState, sdk) => {
  const { page = 1, id } = param;
  dispatch(fetchAllBlockedWorkersRequest());

  await dispatch(fetchCurrentUser());
  const fetchedcurrentUser = getState().user.currentUser;
  const blockerid = fetchedcurrentUser?.attributes?.profile?.protectedData?.favourites || [];

  return axios
    .post(
      `${apiBaseUrl()}/api/user/getBlockedUsers`,
      {
        blockerid: id,
      },
      { withCredentials: true }
    )
    .then(response => {
      const userIds = response?.data?.map(m => m?.blockedWorkerId);
      const data = Promise.all(
        userIds.map(m =>
          sdk.users.show(
            {
              id: m,
              include: ['profileImage'],
              'fields.image': [
                'variants.default',
                'variants.square-small',
                'variants.square-small2x',
              ],
            },
            { expand: true }
          )
        )
      );

      data.then(res => {
        const blockedWorkersId = res.map(m => m.data.data.id);
        const apiResp = {
          status: 200,
          statusText: '',
          data: {
            data: res.map(m => m.data.data),
            included: res.reduce((pre, curnt) => {
              pre.push(...(curnt.data.included || []));
              return pre;
            }, []),
          },
        };
        apiResp.data.data.map(m =>
          dispatch(fetchCurrentWorkerUserExtraDetails(m?.id?.uuid)).then(res => {
            Object.assign(m?.attributes?.profile?.publicData, res);
          })
        );

        dispatch(addMarketplaceEntities(apiResp));
        dispatch(fetchAllBlockedWorkersSuccess(blockedWorkersId));
      });
    })
    .catch(error => {
      dispatch(fetchAllBlockedWorkersError(error));
    });
};

export const fetchPendingApproval = param => async (dispatch, getState, sdk) => {
  const { page = 1 } = param;
  dispatch(fetchAllUnverifiedWorkersRequest());
  await dispatch(fetchCurrentUser());
  const fetchedcurrentUser = getState().user.currentUser;
  const gigsAssigned = fetchedcurrentUser?.attributes?.profile?.publicData?.gigsAssigned || [];
  return sdk.listings
    .query({
      ids: gigsAssigned,
      page,
    })
    .then(response => {
      dispatch(fetchAllUnverifiedWorkersSuccess(response));
    })

    .catch(error => {
      dispatch(fetchAllUnverifiedWorkersError(error));
    });
};

export const fetchListingTransactions = (
  listingId,
  perPage = 4,
  page = 1,
  txTransitionArrayMaybe = []
) => (dispatch, getState, sdk) => {
  let apiResp;
  dispatch(fetchListingTransactionsRequest());
  return sdk.transactions
    .query({
      only: 'sale',
      listingId,
      lastTransitions: ['transition/request-zero-payment', ...txTransitionArrayMaybe],
      perPage,
      page,
      include: [
        'customer',
        'customer.profileImage',
        'customer.profile.displayName',
        'customer.profile.publicData',
        'listing',
        'listing.title',
        'listing.publicData',
        'listing.price',
      ],
    })
    .then(response => {
      let finalData = [];
      apiResp = response;
      response.data.data.reduce((acc, curr) => {
        let data = { transaction: curr };
        let customer = response.data.included.find(
          ({ id }) => id.uuid === curr.relationships.customer.data.id.uuid
        );

        // let listing = response.data.included.find(
        //   ({ id }) => id.uuid === curr.relationships.listing.data.id.uuid
        // );
        dispatch(
          addMarketplaceEntities({
            data: { data: customer, included: response.data.included },
            status: 200,
            statusText: 'ok',
          })
        );
        customer.profileImage = response.data.included.find(
          ({ id }) => id.uuid === curr.relationships.customer.data.id.uuid
        ).relationships?.profileImage?.data?.id?.uuid;

        finalData = [
          ...finalData,
          {
            ...data,
            customer,
          },
        ];
      }, {});

      return finalData;
    })
    .then(response => {
      dispatch(
        fetchListingTransactionsSuccess({
          data: response.map(res => ({
            ...res,
            customer: getMarketplaceEntities(getState(), [
              { id: res.customer.id, type: 'user' },
            ])?.[0],
          })),
          listingId,
        })
      );
      return apiResp;
    })
    .catch(error => { });
};
export const fetchListingPendingApprovals = ({
  userIds,
  listingData: { listingIds, listingUsers },
}) => async (dispatch, getState, sdk) => {
  dispatch(fetchListingTransactionsRequest());
  const currentDate =
    moment()
      .startOf('day')
      .valueOf() / 1000;
  const listingsResp = await sdk.listings.query(
    {
      ids: listingIds,
      pub_gigStartDateInNumberFormat: `${currentDate},`,
    },
    { expand: true }
  );

  const demoArr = listingsResp.data.data?.map((listing, index) => ({
    listing,
    users: [],
  }))
  return dispatch(
    fetchListingAwaitingAcceptanceSuccess({ data: demoArr, meta: listingsResp.data.meta })
  );
};

export const loadData = (params, search) => async (dispatch, getState, sdk) => {
  const queryParams = parse(search);
  const queryPage = queryParams.page || 1;
  const tab = queryParams.tab || 'WorkingStaffs';
  const slug = params.slug;
  const { page = 1, id } = parse(search);

  const onlyFilterValues = {
    allWorkers: 'WorkingStaffs',
    approvalPending: 'AwaitingTab',
  };

  const onlyFilter = onlyFilterValues[tab];

  if (tab === 'WorkingStaffs') {
    return dispatch(fetchWorkingStaff({ page }));
  }

  if (tab === 'FavouritesTab') {
    return dispatch(fetchFavourites({ page }));
  }

  if (tab === 'AppliedTab') {
    dispatch(fetchAppliedListRequest());
    if (!id) {
      return Promise.reject(new Error(`Invalid id`));
    }

    try {
      const data = await dispatch(
        searchListings({
          tab: 'AppliedJob',
          authorId: id,
          pub_hasApplied: true,
          page,
        })
      );
      const {
        SearchPage: { currentPageResultIds },
      } = getState();
      let promises = [];
      currentPageResultIds.forEach(id => {
        const ref = { id, type: 'listing' };
        const listings = getMarketplaceEntities(getState(), [ref]);
        promises.push(dispatch(fetchListingTransactions(id.uuid)));
      });

      await Promise.all(promises);
      return dispatch(fetchAppliedListSuccess());
    } catch (err) {
      return dispatch(fetchAppliedListError(err));
    }
  }

  if (tab === 'AwaitingTab') {
    dispatch(fetchListingAwaitingAcceptanceRequest());
    if (!id) {
      return Promise.reject(new Error(`Invalid id`));
    }
    try {
      const data = await dispatch(fetchCurrentUser());
      const {
        user: { currentUser },
      } = getState();
      const iiii = await axios.post(`${apiBaseUrl()}/api/user/getAssignedDataByBusinessId`, {
        businessId: currentUser.id.uuid,
        page: 0,
      });
      const listingIds = [];
      const listingUsers = [];
      const queryUser = iiii.data.data.reduce((total, current) => {
        listingIds.push(current.listingId);
        listingUsers.push({
          listingId: current.listingId,
          workers: current?.data?.map(d => d.workerId),
        });
        return [...new Set([...total, ...current?.data?.map(d => d.workerId)])];
      }, []);

      return dispatch(
        fetchListingPendingApprovals({
          userIds: queryUser,
          listingData: { listingIds, listingUsers },
        })
      );
    } catch (err) {
      return dispatch(fetchListingAwaitingAcceptanceError(err));
    }
  }
  if (tab === 'BlockedTab') {
    return dispatch(fetchBlockedUser({ page, id }));
  }
};
